export default [
  {
    path: '/reports/helpdesk', name: 'helpdesk-reports',
    meta: { title: 'Help Desk Reports', authRequired: true, privileges: ['VIEW_TICKETS'] },
    component: () => import('../views/reports/helpdesk-catalogue.vue'),
  },
  {
    path: '/reports/helpdesk/:reportCode', name: 'helpdesk-report-runner',
    meta: { title: 'Help Desk Report', authRequired: true, privileges: ['VIEW_TICKETS'] },
    component: () => import('../views/reports/helpdesk-report-runner.vue'),
  },
  {
    path: '/helpdesk/dashboard',
    name: 'helpdesk-dashboard',
    meta: { title: 'Help Desk Reporting', authRequired: true, privileges: ['VIEW_TICKETS'] },
    component: () => import('../views/helpdesk/dashboard'),
  },  {
    path: '/helpdesk/helpdesk-forms',
    name: 'helpdesk-forms',
    meta: {
      title: "Helpdesk Forms",
      authRequired: true,
      privileges: [
        'UPDATE_ROLE',
        'VIEW_FORMS',
      ]
    },
    component: () => import("../views/helpdesk/helpdesk-forms"),
  },
  {
    path: '/helpdesk/manage-form',
    name: 'manage-form',
    meta: {
      title: "Manage Form",
      authRequired: true,
      privileges: [
        'UPDATE_ROLE',
        'VIEW_FORMS',
      ]
    },
    component: () => import("../views/helpdesk/manage-form"),
  },
  {
    path: '/helpdesk/interaction-settings',
    name: 'interaction-settings',
    meta: {
      title: "Helpdesk Interaction Settings",
      authRequired: true,
      privileges: [
        'UPDATE_ROLE',
        'VIEW_FORMS',
      ]
    },
    component: () => import("../views/helpdesk/interaction-settings"),
  },
  {
    path: '/helpdesk/manage-interaction-category',
    name: 'manage-interaction-category',
    meta: {
      title: "Manage Interaction Category",
      authRequired: true,
      privileges: [
        'UPDATE_ROLE',
        'VIEW_FORMS',
      ]
    },
    component: () => import("../views/helpdesk/manage-interaction-category"),
  },
  {
    path: '/helpdesk/manage-interaction',
    name: 'manage-interaction',
    meta: {
      title: "Manage Interaction",
      authRequired: true,
      privileges: [
        'UPDATE_ROLE',
        'VIEW_FORMS',
      ]
    },
    component: () => import("../views/helpdesk/manage-interaction"),
  },
  {
    path: '/helpdesk/ticket-type-settings',
    name: 'ticket-type-settings',
    meta: {
      title: "Query Type Settings",
      authRequired: true,
      privileges: [
        'UPDATE_ROLE',
        'MANAGE_HELPDESK_QUERY_TYPES',
      ]
    },
    component: () => import("../views/helpdesk/ticket-type-settings"),
  },
  {
    path: '/helpdesk/manage-ticket-type',
    name: 'manage-ticket-type',
    meta: {
      title: "Manage Ticket Type",
      authRequired: true,
      privileges: [
        'UPDATE_ROLE',
        'VIEW_FORMS',
      ]
    },
    component: () => import("../views/helpdesk/manage-ticket-type"),
  },
  {
    path: '/helpdesk/contacts',
    name: 'helpdesk-contacts',
    meta: {
      title: "Helpdesk Contacts",
      authRequired: true,
      privileges: [
        'UPDATE_ROLE',
        'VIEW_QUERIES',
      ]
    },
    component: () => import("../views/helpdesk/contacts"),
  },
  {
    path: '/helpdesk/contact',
    name: 'helpdesk-contact',
    meta: {
      title: "Helpdesk Contacts",
      authRequired: true,
      privileges: [
        'UPDATE_ROLE',
        'VIEW_QUERIES',
      ]
    },
    component: () => import("../views/helpdesk/manage-contact"),
  },
  {
    path: '/helpdesk/interactions',
    name: 'helpdesk-interactions',
    meta: {
      title: "Helpdesk Interactions",
      authRequired: true,
      privileges: [
        'UPDATE_ROLE',
        'VIEW_QUERIES',
      ]
    },
    component: () => import("../views/helpdesk/interactions"),
  },
  {
    path: '/helpdesk/chat-conversations',
    name: 'helpdesk-chat-conversations',
    meta: {
      title: "Chat Conversations",
      authRequired: true,
      privileges: [
        'UPDATE_ROLE',
        'VIEW_INTERACTIONS',
      ]
    },
    component: () => import("../views/helpdesk/chat-conversations"),
  },
  {
    path: "/helpdesk/tickets",
    name: "helpdesk-tickets",
    meta: {
      title: "Helpdesk Tickets",
      authRequired: true,
      privileges: [
        'UPDATE_ROLE',
        'VIEW_QUERIES',
      ]
    },
    component: () => import("../views/helpdesk/tickets"),
  },
  {
    path: '/helpdesk/manage-ticket',
    name: 'manage-ticket',
    meta: {
      title: "Manage Ticket",
      authRequired: true,
      privileges: [
        'UPDATE_ROLE',
        'VIEW_FORMS',
      ]
    },
    component: () => import("../views/helpdesk/manage-ticket"),
  },
  {
    path: '/helpdesk/view-ticket',
    name: 'view-ticket',
    meta: {
      title: "View Ticket",
      authRequired: true,
      privileges: [
        'UPDATE_ROLE',
        'VIEW_FORMS',
      ]
    },
    component: () => import("../views/helpdesk/view-ticket"),
  },
  /*{
    path: '/helpdesk/view-ticket',
    name: 'view-ticket',
    meta: {
      title: "View Ticket",
      authRequired: true,
      privileges: [
        'UPDATE_ROLE',
        'VIEW_FORMS',
      ]
    },
    component: () => import("../views/helpdesk/ViewTicket"),
  },*/
  // Integration Channels
  {
    path: '/helpdesk/calls',
    name: 'channel-email',
    meta: {
      title: "Helpdesk Phone Call Channel",
      authRequired: true,
      privileges: [
        'UPDATE_ROLE',
        'VIEW_QUERIES',
      ]
    },
    component: () => import("../views/helpdesk/calls"),
  },
  {
    path: '/helpdesk/emails',
    name: 'channel-email',
    meta: {
      title: "Helpdesk Email Channel",
      authRequired: true,
      privileges: [
        'UPDATE_ROLE',
        'VIEW_QUERIES',
      ]
    },
    component: () => import("../views/helpdesk/emails"),
  },
  {
    path: '/helpdesk/facebook',
    name: 'channel-facebook',
    meta: {
      title: "Helpdesk Facebook Channel",
      authRequired: true,
      privileges: [
        'UPDATE_ROLE',
        'VIEW_QUERIES',
      ]
    },
    component: () => import("../views/helpdesk/facebook"),
  },
  {
    path: '/helpdesk/whatsapp',
    name: 'channel-whatsapp',
    meta: {
      title: "Helpdesk WhatsApp Channel",
      authRequired: true,
      privileges: [
        'UPDATE_ROLE',
        'VIEW_QUERIES',
      ]
    },
    component: () => import("../views/helpdesk/whatsapp"),
  },
  {
    path: "/helpdesk/customer-details",
    name: "helpdesk-clients",
    meta: {
      title: "helpdesk-clients",
      authRequired: true,
      privileges: [
        'UPDATE_ROLE',
        'VIEW_CONTACTS',
        'VIEW_CUSTOMERS',
        'MANAGE_CONTACTS',
        'MANAGE_CUSTOMERS',
      ]
    },
    component: () => import("../views/helpdesk/customer"),
  },

  {
    path: "/helpdesk/query-details",
    name: "helpdesk-query-details",
    meta: {
      title: "Query Details",
      authRequired: true,
      privileges: [
        'UPDATE_ROLE',
        'VIEW_QUERY_DETAILS',
      ]
    },
    component: () => import("../views/helpdesk/query-details"),
  },
  {
    path: '/helpdesk/knowledge-base',
    name: 'knowledge-base',
    meta: {
      title: "Knowledge Base",
      authRequired: true,
      privileges: [
        'VIEW_KNOWLEDGE_BASE',
      ]
    },
    component: () => import("../views/helpdesk/knowledge-base"),
  },
  {
    path: '/helpdesk/knowledge-base',
    name: 'knowledge-base-article',
    meta: {
      title: "Knowledge base",
      authRequired: true,
      privileges: [
        'UPDATE_ROLE',
        'VIEW_KNOWLEDGE_BASE_ARTICLE',
      ]
    },
    component: () => import("../views/helpdesk/knowledge-base-article"),
  },
  {
    path: '/helpdesk/knowledge-base-settings',
    name: 'knowledge-base-settings',
    meta: {
      title: "Article Settings",
      authRequired: true,
      privileges: [
        'UPDATE_ROLE',
        'MANAGE_KNOWLEDGE_BASE_SETTINGS',
      ]
    },
    component: () => import("../views/helpdesk/knowledge-base-settings"),
  },
  {
    path: '/helpdesk/lodge-query',
    name: 'lodge-query',
    meta: {
      title: "Lodge Query",
      authRequired: true,
      privileges: [
        'LODGE_QUERY',
        'UPDATE_ROLE',
      ]
    },
    component: () => import("../views/helpdesk/lodge-query"),
  },
]
